import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {  FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { AppMainService } from '../../../../../app/app-main.service';
import { AppMainComponent } from '../../../../../app/app.main.component';
import { Status } from '../../../../../app/models/statusEnums';
import { ObjectLogService } from '../../../../../app/shared/api/api';
import { LogAttachment, ObjectLog } from '../../../../../app/shared/model/models';
import { uploadFiles, validateFiles } from '../../../../../app/shared/upload-files';
import { LogService } from './log-service.service';
import { ObjectNote } from '../../model/models';
import { ObjectNoteService } from "../../api/api";
import { environment } from 'src/environments/environment';
import {  Router } from '@angular/router';
import { AccountServiceN } from 'src/app/accounts-v2/services/account.services';
import { Subscription } from 'rxjs';

@Component({
    selector: "app-lion-shared-logs",
    templateUrl: "./shared-logs.component.html",
    styleUrls: ["./shared-logs.component.scss"],
    providers: [ObjectLogService],
})
export class LionSharedLogsComponent implements OnInit {
    @Input() displayAddLog;
    @Output() cancelLog: EventEmitter<any> = new EventEmitter();
    @ViewChild("createLog") createLog: FormGroupDirective;
    private userAccessSubscription: Subscription | null = null;
    assestBaseUrl: string = environment.assestsBasePath;

    logs = [];
    sublogs = [];
    selectedLog = {
        name: "Mobile",
        groupId: 4,
        parentTypeId: 0,
        description: "Mobile Log Type",
        id: 5,
        createdSource: "10.1.1.1",
        updatedSource: null,
        createdBy: this.app.user.userId,
        updatedBy: this.app.user.userId,
        createdDate: "2020-12-08T15:18:26.293",
        updatedDate: null,
    };
    selectedSubLog = {
        name: "Inbound Call",
        groupId: 5,
        parentTypeId: 0,
        description: "Inbound Call Sub Log Type",
        id: 8,
        createdSource: "10.1.1.1",
        updatedSource: null,
        createdBy: this.app.user.userId,
        updatedBy: this.app.user.userId,
        createdDate: "2020-12-09T11:36:23.103",
        updatedDate: null,
    };
    multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
      <li>Files with extensions: gif, png, jpg, jpeg, pdf, txt, xls, xlsx, doc, docx, ppt, pptx are allowed</li>
      <li>Files size should not be more than 2MB</li>
    </ul>
  `;

    logTemp: ObjectLog = {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        objectId: 0,
        objectTypeId: 0,
        logId: 0,
        log: {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            commentMessage: "",
            typeId: 0,
            subTypeId: 0,
            organizationId: this.app.user.organizationId,
            description: "",
            statusId: Status.Active,
            isValid: true,
            validFromDate: null,
            validToDate: null,
            logComments: null,
            logAttachments: [],
        },
    };

    logAttachment: LogAttachment = {
        id: 0,
        createdSource: this.app.userIP,
        createdBy: this.app.user.userId,
        createdDate: new Date(),
        logId: 0,
        attachmentId: 0,
        attachment: {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            createdDate: new Date(),
            name: "",
            guidName: "",
            content: "",
            extension: "",
            sizeInBytes: 0,
            description: "",
            statusId: 0,
            isValid: true,
            validFromDate: null,
            validToDate: null,
        },
    };
    allowedExtensions = [
        ".pdf",
        ".csv",
        ".txt",
        ".xlsx",
        ".xls",
        ".docx",
        ".doc",
        ".png",
        ".jpg",
        ".jpeg",
        ".ppt",
        ".pptx",
        ".gif",
        ".zip",
    ]; // For the attachment files
    disableSubmitButton = false;
    countForPreventDoubleClick: number = 0;
    users = [];
     commentForm!: FormGroup;
  /**Quill config */
  quillConfig={
    toolbar: false,
    mention: {
      allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
      mentionDenotationChars: ["@"],
      showDenotationChar: false,
      spaceAfterInsert: false,
      source: (searchTerm, renderList, mentionChar) => {
        let values = this.users || [];
    
        if (searchTerm.length === 0) {
          renderList(values, searchTerm);
        } else {
          const matches = values.filter(user =>
            user.value?.toLowerCase().includes(searchTerm.toLowerCase())
          );
          renderList(matches, searchTerm);
        }
      },
    },
  }
    constructor(
        private app: AppMainComponent,
        private logService: LogService,
        private appMainService: AppMainService,
        private objectLogService: ObjectLogService,
        private noteService: ObjectNoteService,
        private messageService: MessageService,private fb: FormBuilder,
        private router: Router,
        private accountService: AccountServiceN,
    ) {
        const endpoint = this.router.url.split('/')[1];
        if (endpoint === 'accounts') {
            this.userAccessSubscription = this.accountService.userAccess$.subscribe((accessData) => {
              this.users = accessData.map((user) => ({
                id: user.userId,
                value: user.userName,
              }));
            });
          } else {
          this.users = this.app.usersList.map((user) => ({
            id: user.id,
            value: user.name,
          }));
        }
}

    ngOnInit(): void {
        this.app.logTypesBSubject.subscribe((logTypes) => {
            if (logTypes.length) {
                this.logs = logTypes;
                this.selectedLog =
                    logTypes && logTypes.length ? logTypes[0] : null;
                if (this.selectedLog) {
                    this.getSublogType();
                }
            }
        });
        if (!this.app.allObjects || !this.app.allObjects.length) {
            let object = this.app.preLoadedObjects.map(elem => {
                return { name: elem.name, id: this.app.objectId, type: elem.id }
            });
            this.app.allObjects = object;
        }
    }

    getSublogType() {
        this.logService
            .getSubLogTypes(this.selectedLog.id)
            .then((types: any) => {
                types = types ? types : [];
                this.sublogs = types;
                this.selectedSubLog = types.length ? types[0] : null;
            });
    }

    uploadAttachments(files: File[], fileUpload: FileUpload) {
        this.appMainService.isShowSpinner("upload");
        if (typeof Worker !== undefined) {
            let count = 0;
            for (let file of files) {
                let errors = validateFiles(file, 2, this.allowedExtensions);
                if (errors.length > 0) {
                    for (let error of errors) {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                    this.appMainService.isHideSpinner("upload");
                } else {
                    uploadFiles(file, ({ name, content, size, extension }) => {
                        const lastIndex = name.lastIndexOf(".");
                        const fileName = name.substring(0, lastIndex);

                        this.logAttachment.attachment = {
                            id: 0,
                            content,
                            name: fileName,
                            extension,
                            isValid: true,
                            sizeInBytes: size,
                            statusId: Status.Active,
                            createdBy: this.app.user.userId,
                            createdDate: new Date(),
                            createdSource: this.app.userIP,
                        };
                        this.logTemp.log.logAttachments.push(
                            this.app.copyObjectWithoutRefrence(
                                this.logAttachment
                            )
                        );
                    });
                    this.appMainService.isHideSpinner("upload");
                }
                count++;
                if (count === files.length) {
                    fileUpload.clear();
                }
            }
        } else {
            this.appMainService.isHideSpinner("upload");
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }

    cancel() {
        this.selectedLog = this.logs[0];
        this.getSublogType();

        this.logTemp = {
            id: 0,
            createdSource: this.app.userIP,
            createdBy: this.app.user.userId,
            objectId: 0,
            objectTypeId: 0,
            logId: 0,
            log: {
                id: 0,
                createdSource: this.app.userIP,
                createdBy: this.app.user.userId,
                commentMessage: "",
                typeId: 0,
                subTypeId: 0,
                organizationId: this.app.user.organizationId,
                description: "",
                statusId: Status.Active,
                isValid: true,
                validFromDate: null,
                validToDate: null,
                logComments: null,
                logAttachments: [],
            },
        };
        this.displayAddLog = false;
        this.cancelLog.emit({ cancelLog: this.displayAddLog });
    }

    onBlur(comment: any) {
        comment.control.markAsTouched(); 
      }
  
    onSubmit(comment) {
        const mentionUsers = this.getMentions(comment);
        const selectedUserIds = mentionUsers.map(user => user.id);
        return (selectedUserIds);
    }
      getMentions(comment: string) {
        const mentionRegex = /<span class="mention"[^>]*data-id="(.*?)"[^>]*data-value="(.*?)"[^>]*>/g;
        let mentions: { id: number; name: string }[] = [];
        let uniqueMentionsMap = new Map<number, { id: number; name: string }>();
        let match;
        while ((match = mentionRegex.exec(comment)) !== null) {
          const id = parseInt(match[1], 10);
          const name = match[2];
          uniqueMentionsMap.set(id, { id, name });
        }
        mentions = Array.from(uniqueMentionsMap.values());
        return mentions;
      }
    addLog() {
        const selectedUserIds = this.onSubmit(this.logTemp.log.commentMessage);
        if (this.createLog.form.valid) {

            if(this.selectedLog?.name=='Note'){
                this.addNote();
                return;
            }

            this.appMainService.isShowSpinner("addLog");
            this.disableSubmitButton = true;

            let logData: ObjectLog = JSON.parse(JSON.stringify(this.logTemp));
            logData.createdBy = this.app.user.userId;
            logData.createdDate = new Date().toISOString();
            logData.createdSource = this.app.userIP;
            logData.mentionedUserIds = selectedUserIds ;
            logData.objectId = this.app.objectId;
            if(this.app?.allObjects?.length > 0){
                logData.objectTypeId = this.app.allObjects.filter(
                    (elem) => elem.name === this.app.objectType
                )[0].type;
            }
            // else{
            //     logData.objectTypeId = JSON.parse(localStorage.getItem('LionO360_Object')).map(elem => {
            //         return { name: elem.name, id: this.app?.objectId, type: elem?.id }
            //     }).filter(
            //         (elem) => elem.name === this.app.objectType
            //     )[0].type;
            // }
            logData.log.createdBy = this.app.user.userId;
            logData.log.createdDate = new Date().toISOString();
            logData.log.createdSource = this.app.userIP;
            logData.log.typeId = this.selectedLog.id;
            logData.log.subTypeId =
                this.selectedSubLog && this.selectedSubLog.id
                    ? this.selectedSubLog.id
                    : null;
            this.objectLogService
                .lionO36020APIObjectLogPost(logData)
                .toPromise()
                .then((res) => {
                    this.disableSubmitButton = false;
                    this.countForPreventDoubleClick = 0;
                    this.appMainService.isHideSpinner("addLog");
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Log saved successfully...",
                    });
                    this.cancel();
                    //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
                    this.app.getAllObjects(true, false, false);
                })
                .catch((errResp) => {
                    this.appMainService.isHideSpinner("addLog");
                    this.disableSubmitButton = false;

                    if(this.logTemp?.log?.logAttachments.filter(att=>att?.attachment?.name?.length>50)?.length>0){
                        this.messageService.add({ severity: 'error', summary: 'Filename too long', detail: "Maximum 200 characters filename allowed!" });
                    }else{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: errResp.error.Message });
                    }
                });
        } else {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please fill out required information...",
            });
        }
    }

    addNote(){
        const selectedUserIds = this.onSubmit(this.logTemp.log.commentMessage);
        let logData: ObjectLog = JSON.parse(JSON.stringify(this.logTemp));
        const notesTemp: ObjectNote = {
            "id": 0,
            "createdSource": this.app.userIP,
            "createdBy": this.app.user.userId,
            "createdDate": new Date(),
            "objectId": this.app.objectId,
            "mentionedUserIds" : selectedUserIds ,
            "objectTypeId": this.app.allObjects.filter(
                (elem) => elem.name === this.app.objectType
            )[0].type,
            "noteId": 0,
            "note": {
              "id": 0,
              "createdSource": this.app.userIP,
              "createdBy": this.app.user.userId,
              "createdDate": new Date(),
              "comment": logData.log.commentMessage,
              "isImportant": false,
              "organizationId":  this.app.user.organizationId,
              "description": "",
              "statusId": Status.Active,
              "isValid": true,
              "validFromDate": null,
              "validToDate": null,
              "noteComments": null,
              "noteAttachments": (logData.log.logAttachments as any)||[]
            }
        }

        this.appMainService.isShowSpinner("addNote");
        this.disableSubmitButton = true;

        this.noteService.lionO36020APIObjectNotePost(notesTemp).toPromise()
        .then(note => {
            this.disableSubmitButton = false;
            this.countForPreventDoubleClick = 0;
            this.appMainService.isHideSpinner("addNote");
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note saved successfully...' });
            this.cancel();
            this.app.getAllObjects(true, false, false);
        }).catch(errResp => {
            this.appMainService.isHideSpinner("addNote");
            this.disableSubmitButton = false;
            if(notesTemp?.note?.noteAttachments.filter(att=>att?.attachment?.name?.length>50)?.length>0){
                this.messageService.add({ severity: 'error', summary: 'Filename too long', detail: "Maximum 200 characters filename allowed!" });
            }else{
                this.messageService.add({ severity: 'error', summary: 'Error', detail: errResp.error.Message });
            }
        });
    }

    removeAttachment(attachments){
        this.logTemp.log.logAttachments = attachments.filter(att=>att?.attachment?.statusId != Status.Deleted);
    }
    
    ngOnDestroy() {
        this.userAccessSubscription?.unsubscribe();
      }
}
